import fetchApi from "../fetchApi";

const prettifyRoleName = (name) =>
  (name || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

// Fetches the company's active dynamic roles and maps them to react-select
// options. `value` is the role id (for assignment); `name` is the raw role
// name (for office visibility).
export const GetUserRoles = async () => {
  try {
    const response = await fetchApi("roles?per_page=100&is_active=true", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
      redirect: "follow",
    });

    const roles = response.roles || [];

    return roles.map((role) => ({
      value: role.id,
      label: prettifyRoleName(role.name),
      name: role.name,
    }));
  } catch (error) {
    console.error("Error fetching user roles:", error);
    throw error;
  }
};
